import React from 'react'
import LatinoTemplateDefault from 'src/components/template/la/'
import { videos } from 'src/constants/videos'
import { laChannelCount } from 'src/constants/planData/latinoPlanData'
import { useIsLatinoBundleAvailable } from 'src/modules/hooks/useIsLatinoBundleAvailable'
import styled from 'styled-components'
import { leagueIds, sportIds } from 'src/constants'
export default (props) => {
  const latinoBundlePlan = useIsLatinoBundleAvailable({ lang: 'en' })
  const isLatinoBundleAvailable = latinoBundlePlan !== null

  let title = (
    <>
      Watch MLB live <span className="no-wrap">in Spanish</span>
    </>
  )
  let subtitle = `Enjoy baseball all season long and get access to ${laChannelCount}+ channels of live TV`
  if (latinoBundlePlan?.rsnName) {
    title = 'Watch MLB live'
    subtitle = `Follow your local teams with ${
      latinoBundlePlan?.rsnName ?? 'FanDuel Sports Network'
    } and get access to ${laChannelCount}+ channels of live TV`
  }

  return (
    <StyledContainer>
      <LatinoTemplateDefault
        location={props.location}
        lang="en"
        market="latino"
        video={videos.mlbtv.videoUrl}
        title={title}
        subtitle={subtitle}
        noteLink="/la/mlb-es/"
        pageDescription={
          'Stream FanDuel Sports Network, FOX Deportes, ESPN Deportes, beIN SPORTS and more with Fubo.'
        }
        networkSet={'entertainmentLatino'}
        customNetworks={['espndeportes']}
        disableLAPlanCards={isLatinoBundleAvailable}
        forceAnchorLink={isLatinoBundleAvailable}
        hasPlanCards={isLatinoBundleAvailable}
        plans={[latinoBundlePlan]}
        sportId={sportIds.Baseball}
        leagueId={leagueIds.MLB}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div``
